export const DOMAIN = 'https://www.tornado.com';
export const WEB_URL = '/app';

export const LOG_ADJUST_EVENTS = false;
